export default __webpack_public_path__ + "static/images/logo-white-3b99c7349a269eab714c56aa4dc52a17.png";